// width: 100% is temporary till the actual data arrives

import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import {Grid, Typography, Switch, withWidth} from '@material-ui/core';
import {isWidthUp} from '@material-ui/core/withWidth';
import classNames from 'classnames';
import {Fade} from 'react-reveal';

const imagePath = "/images/features.png";
const styles = theme => ({
  root: {
    transition: 'background-color .3s ease-in-out',
    padding: theme.spacing.unit * 12,
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing.unit * 8
    },
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing.unit * 4
    }
  },
  light: {
    backgroundColor: theme.palette.background.paper
  },
  dark: {},
  tagLine: {
    textTransform: 'uppercase',
    fontWeight: 'bold',
    paddingBottom: theme.spacing.unit * 2
  },
  lightModeTagLine: {
    color: theme.palette.secondary.dark
  },
  image: {
    maxWidth: '100%',
  },
  switchName: {
    textTransform: 'uppercase',
    fontWeight: 'bold',
    fontSize: theme.spacing.unit * 1.8
  },
  darkSwitchText: {
    color: theme.palette.secondary.main,
    fontWeight: 'bold'
  },
  icon: {
    height: 40,
    width: 40
  },
  bottomTextContainer: {
    paddingTop: theme.spacing.unit * 6,
  },
  barStyle: {
    backgroundColor: theme.palette.text.primary
  },
  lightModeBarStyle: {
    backgroundColor: theme.palette.divider
  }
});

class Features extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      darkMode: true
    };
    this.handleToggle = this.handleToggle.bind(this);
  }

  handleToggle() {
    this.setState((prevState) => ({darkMode: !prevState.darkMode}))
  }

  render() {
    const {classes, width} = this.props;
    return (
      <div className={classNames(classes.root, !this.state.darkMode ? classes.light : classes.dark)}>
        <Grid container direction="column" justify="space-evenly" alignItems="stretch">
          <Fade bottom duration={1500} cascade={true} distance="100px">
            <Grid item style={{alignSelf: 'baseline'}}>
              <Typography variant="caption" color="secondary" gutterBottom
                          className={classNames(classes.tagLine, !this.state.darkMode ? classes.lightModeTagLine : '')}>
                Features
              </Typography>
            </Grid>
            <Grid item>
              <Grid container justify="space-between" alignItems="center">
                <Grid item>
                  <Typography variant={isWidthUp('md', width, false) ? 'h3' : 'h4'}
                              color={!this.state.darkMode ? 'inherit' : 'default'} gutterBottom>
                    Explore a world of
                    <div style={{fontWeight: 'bold'}}> Digital and Fiat Assets.</div>
                  </Typography>
                </Grid>
                <Grid item>
                <span className={classes.switchName}>
                  <Typography variant="caption" color={!this.state.darkMode ? 'primary' : 'default'}
                              style={{display: 'inline-block'}}>
                    Light Mode
                  </Typography>
                </span>
                  <Switch
                    classes={{bar: this.state.darkMode ? classes.barStyle : classes.lightModeBarStyle}}
                    checked={this.state.darkMode}
                    onChange={this.handleToggle}
                    value="darkMode"
                  />
                  <span className={classes.switchName}>
                  <Typography variant="caption" color={!this.state.darkMode ? 'primary' : 'inherit'}
                              style={{display: 'inline-block'}}
                              className={this.state.darkMode ? classes.darkSwitchText : ''}>
                     Dark Mode
                  </Typography>
                </span>
                </Grid>
              </Grid>
            </Grid>
            <Grid item>
              <img src={imagePath} alt="Features" className={classes.image}/>
            </Grid>
            <Grid item className={classes.bottomTextContainer}>
              <Grid container direction="row" justify="center" alignItems="stretch" spacing={24}>
                {/* Box 1 */}
                <Grid item xs={12} sm={12} md={4}>
                  <Grid container direction="row">
                    <Grid item xs={2}>
                      <img src="/images/icons/features/basic-and-advance-view.svg" alt="Icon" className={classes.icon}/>
                    </Grid>
                    <Grid item xs={10}>
                      <Typography variant="h6" color={!this.state.darkMode ? 'inherit' : 'default'}>Basic and Advanced
                        Trading
                        View</Typography>
                      <Typography variant="body2" color={!this.state.darkMode ? 'inherit' : 'default'}>User friendly to
                        both
                        Beginners and Professionals.</Typography>
                    </Grid>
                  </Grid>
                </Grid>
                {/* Box 2 */}
                <Grid item xs={12} sm={12} md={4}>
                  <Grid container direction="row">
                    <Grid item xs={2}>
                      <img src="/images/icons/features/cryptx-instant.svg" alt="Icon" className={classes.icon}/>
                    </Grid>
                    <Grid item xs={10}>
                      <Typography variant="h6" color={!this.state.darkMode ? 'inherit' : 'default'}>CryptX
                        Instant</Typography>
                      <Typography variant="body2" color={!this.state.darkMode ? 'inherit' : 'default'}>Instantly fill
                        buy
                        / sell
                        orders and skip waiting queues.</Typography>
                    </Grid>
                  </Grid>
                </Grid>
                {/* Box 3 */}
                <Grid item xs={12} sm={12} md={4}>
                  <Grid container direction="row">
                    <Grid item xs={2}>
                      <img src="/images/icons/features/complete-range-of-orders.svg" alt="Icon"
                           className={classes.icon}/>
                    </Grid>
                    <Grid item xs={10}>
                      <Typography variant="h6" color={!this.state.darkMode ? 'inherit' : 'default'}>Complete Range of
                        Orders</Typography>
                      <Typography variant="body2" color={!this.state.darkMode ? 'inherit' : 'default'}>Over 10+
                        Different
                        Fiat &
                        Digital Assets.</Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Fade>
        </Grid>
      </div>
    )
  }
}

export default withWidth()(withStyles(styles)(Features));
